import { render, staticRenderFns } from "./FeedbackExperience.vue?vue&type=template&id=128ac7cc&scoped=true&"
import script from "./FeedbackExperience.vue?vue&type=script&lang=js&"
export * from "./FeedbackExperience.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackExperience.vue?vue&type=style&index=0&id=128ac7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ac7cc",
  null
  
)

component.options.__file = "FeedbackExperience.vue"
export default component.exports